import Blue from '~/core';

let hasLoadedYTApi = false;

new Blue({
  name: 'Youtube Video Embed Tracking',
  selector: '.video-player__video--embedded',
  setup(video) {
    const data = video.dataset;
    let player;
    let hasPlayed = false;

    if (!hasLoadedYTApi) {
      hasLoadedYTApi = true;
      const ytAPI = document.createElement('script');
      ytAPI.src = 'https://www.youtube.com/iframe_api';
      video.parentNode.insertBefore(ytAPI, video);
      ytAPI.onload = onYouTubeIframeAPILoad;
    }
    else
      onYouTubeIframeAPIReady();

    function onYouTubeIframeAPILoad() {
      const interval = setInterval(() => {
        if (!YT.loaded)
          return;

        clearInterval(interval);
        onYouTubeIframeAPIReady();
      }, 200);
    }

    function onYouTubeIframeAPIReady() {
      player = new YT.Player(video, {
        videoId: data.embedCode,
        events: {
          onStateChange: onPlayerStateChange,
        },
      });
    }
    
    function onPlayerStateChange(event) {
      if (event.data == YT.PlayerState.PLAYING && !hasPlayed) {
        hasPlayed = true;
        sendEvent('play', data);
      }
    }
  },
});

new Blue({
  name: 'Youtube Video Modal',
  selector:
    'a.video-player__video[data-video-embed-code], a.video-player__link[data-video-embed-code]',
  setup(video) {
    let hasPlayed = false;
    const data = video.dataset;
    
    this.$addEvents(video, 'click', function (e) {
      if (e.target.closest('.video-library-dialog__title')) return;

      e.preventDefault();

      if (e.target.closest('.video-library-dialog')) return;

      const videoEmbedCode = data.videoEmbedCode;
      const videoDescription = data.videoDescription;
      const videoTitle = data.videoTitle;

      let modal = document.createElement('dialog');
      modal.classList.add('video-library-dialog');
      modal.classList.add('is-active');
      modal.classList.add('inline');
      modal.innerHTML = `<button class="video-library-dialog__close" aria-label="Close Modal"><i class="fas fa-times"></i></button><div class="video-player is-active"><div class="video-player__video"><iframe src="https://www.youtube.com/embed/${videoEmbedCode}?autoplay=1&color=white&autohide=2&modestbranding=1&border=0&wmode=opaque&enablejsapi=1&showinfo=0&rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe></div><a href="${this.href}" class="video-library-dialog__title">${videoTitle}</a><p class="video-library-dialog__description">${videoDescription}</p></div>`;

      video.appendChild(modal);

      //Fire tracking event
      if (!hasPlayed) {
        hasPlayed = true;
        sendEvent('play', data);
      }

      modal
        .querySelector('.video-library-dialog__close')
        .addEventListener('click', function (e) {
          e.stopPropagation();
          e.preventDefault();
          modal.remove();
        });

      modal.showModal();
    });
  },
});

function getCookie(name) {
  return document.cookie.split("; ").find((c) => c.startsWith(`${name}=`))?.split("=")[1];
}



function sendEvent(action, data) {
  const endpoint = document.querySelector('#activityEndPoint')?.value;
  if (!endpoint) return;
  fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
        "NodeId": data.nodeId || data.videoNodeId,
        "Title": data.title || data.videoTitle,
        "ContactGuid": getCookie('CurrentContact'),
        "Url": data.url || data.videoUrl || data.href,
        "EmbedCode": data.embedCode || data.videoEmbedCode
    })
  });
}